import * as Components from 'components';
import React, { Key } from 'react';
import { SetURLSearchParams } from 'react-router-dom';
import { TableColumnInterface } from 'type/tableType';
import { RevenueInterface } from '../types/revenueDashboardType';
import './RevenueTable.css';

type RevenueTableProps = {
  dataFetch: (params: URLSearchParams) => Promise<{ data: RevenueInterface[]; count: number }>;
  searchParams: URLSearchParams;
  setSearchParams: SetURLSearchParams;
  setSelectedList: (list: number[]) => void;
};
export const RevenueTable: React.FC<RevenueTableProps> = ({
  dataFetch,
  searchParams,
  setSearchParams,
  setSelectedList,
}: RevenueTableProps) => {
  const columns: TableColumnInterface<RevenueInterface>[] = [
    {
      title: 'Year Month',
      dataIndex: 'yearmon',
      key: 'yearmon',
      onFilter: (value: boolean | Key, record: RevenueInterface): boolean =>
        record.yearmon === value,
      sorter: (a: RevenueInterface, b: RevenueInterface) => a.yearmon.localeCompare(b.yearmon),
    },
    searchParams.get('group_by')?.includes('yearmon_content_provider')
      ? {
          title: (): React.ReactNode => <span>Content Provider</span>,
          dataIndex: 'content_provider',
          key: 'content_provider',
          onFilter: (value: boolean | Key, record: RevenueInterface): boolean =>
            record.content_provider === value,
          sorter: true,
        }
      : undefined,
    searchParams.get('group_by')?.includes('yearmon_season')
      ? {
          title: (): React.ReactNode => <span>Season</span>,
          dataIndex: 'title_en',
          key: 'title_en',
          onFilter: (value: boolean | Key, record: RevenueInterface): boolean =>
            record.title_en === value,
          sorter: true,
        }
      : undefined,
    {
      title: 'VH',
      dataIndex: 'vh',
      key: 'vh',
      render: (value: number): React.ReactNode => Number(value).toLocaleString('en-US'),
    },
    {
      title: 'Video Ad Impression',
      dataIndex: 'video_ad_imp',
      key: 'video_ad_imp',
      render: (value: number): React.ReactNode => Number(value).toLocaleString('en-US'),
    },
    {
      title: 'Video Revenue(AVOD)',
      dataIndex: 'video_rev',
      key: 'video_rev',
      render: (value: number): React.ReactNode => Number(value).toLocaleString('en-US'),
    },
    {
      title: 'Display Revenue(AVOD)',
      dataIndex: 'display_rev',
      key: 'display_rev',
      render: (value: number): React.ReactNode => Number(value).toLocaleString('en-US'),
    },
    {
      title: 'Sponsorship Revenue',
      dataIndex: 'sponsorship_rev',
      key: 'sponsorship_rev',
      render: (value: number): React.ReactNode => Number(value).toLocaleString('en-US'),
    },
    {
      title: 'Distribution Revenue',
      dataIndex: 'distribution_rev',
      key: 'distribution_rev',
      render: (value: number): React.ReactNode => Number(value).toLocaleString('en-US'),
    },
    {
      title: 'Theatrical Revenue',
      dataIndex: 'theatrical_rev',
      key: 'theatrical_rev',
      render: (value: number): React.ReactNode => Number(value).toLocaleString('en-US'),
    },
    {
      title: 'SVOD Revenue',
      dataIndex: 'svod_rev',
      key: 'svod_rev',
      render: (value: number): React.ReactNode => Number(value).toLocaleString('en-US'),
    },
    {
      title: 'PPV Revenue',
      dataIndex: 'ppv_rev',
      key: 'ppv_rev',
      render: (value: number): React.ReactNode => Number(value).toLocaleString('en-US'),
    },
    {
      title: 'Total Revenue',
      dataIndex: 'total_rev',
      key: 'total_rev',
      render: (value: number): React.ReactNode => Number(value).toLocaleString('en-US'),
    },
  ].filter(Boolean) as TableColumnInterface<RevenueInterface>[];

  return (
    <Components.TableComponent
      name="Revenue"
      columns={columns}
      options={{ isDisableIdColumn: true }}
      searchParams={searchParams}
      dataFetch={dataFetch}
      setSearchParams={setSearchParams}
      actions={{
        onSelectionChange: setSelectedList,
      }}
    />
  );
};
